module.exports = __webpack_public_path__ + "static/media/NewGoogleCircle.12fe1acf.png";